import { HumanQueueIcon } from './HumanQueueIcon';

/**
 * author: Haley Halcyon
 * id FAD84EF2-E1C0-4834-8FFD-677E424F2693
 * name human-queue
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-queue.svg
 * tags
 * - People / Family 
 */
export const HumanLineIcon = HumanQueueIcon;
export default HumanLineIcon